import { timestampFromDate } from '@bufbuild/protobuf/wkt';
import { z } from 'zod';

export const PERIODS = ['30d', '90d', '12m', 'all'] as const;
export type Period = (typeof PERIODS)[number];

export const dashboardParamsSchema = z.object({
	period: z.enum(PERIODS).optional().catch(undefined),
});
export type DashboardParams = z.infer<typeof dashboardParamsSchema>;

export const DEFAULT_PERIOD: Period = '30d';

/**
 * Start of a period, at midnight so the request stays the same, and cached, for the whole day.
 * Undefined for all time.
 */
export const periodStart = (period: Period, today = new Date()) => {
	const start = new Date(today);
	start.setHours(0, 0, 0, 0);
	switch (period) {
		case '30d':
			start.setDate(start.getDate() - 30);
			return start;
		case '90d':
			start.setDate(start.getDate() - 90);
			return start;
		case '12m':
			start.setFullYear(start.getFullYear() - 1);
			return start;
		case 'all':
			return undefined;
	}
};

export const toDashboardRequest = (period: Period, today?: Date) => {
	const start = periodStart(period, today);
	return { createdAfter: start ? timestampFromDate(start) : undefined };
};
